const LS_SELECTED = "selected_country";
const LS_SOURCE = "selected_country_source";

function safeGet(key) {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

function safeRemove(key) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function normalizeCountryId(value) {
  const n = Number(value);
  return n === 1 || n === 2 ? String(n) : "";
}

export function getStoredSelectedCountry() {
  const raw = safeGet(LS_SELECTED);
  const id = normalizeCountryId(raw);
  const source = safeGet(LS_SOURCE) || "";
  if (!id && raw) {
    safeRemove(LS_SELECTED);
    safeRemove(LS_SOURCE);
    return { id: "", source: "" };
  }
  return { id, source };
}

export function setSelectedCountry(id, source = "user") {
  const normalized = normalizeCountryId(id);
  if (!normalized) return false;
  safeSet(LS_SELECTED, normalized);
  if (source) safeSet(LS_SOURCE, String(source));
  return true;
}

export function clearSelectedCountry() {
  safeRemove(LS_SELECTED);
  safeRemove(LS_SOURCE);
}

export function resolveCountryId({ locationCountry, guestCountry, geoCountry } = {}) {
  const stored = getStoredSelectedCountry();

  // A) explicit user choice
  if (stored.id && (stored.source === "user" || stored.source === "localStorage:user")) {
    return { id: stored.id, source: "localStorage:user" };
  }

  // B) backend guest state or context
  const loc = normalizeCountryId(locationCountry);
  if (loc) return { id: loc, source: "locationContext" };

  const guest = normalizeCountryId(guestCountry);
  if (guest) return { id: guest, source: "guest" };

  // C) geo inference
  const geo = normalizeCountryId(geoCountry);
  if (geo) return { id: geo, source: "geo" };

  // D) legacy stored (non-user) or final default
  if (stored.id && stored.source && stored.source !== "user") {
    return { id: stored.id, source: `localStorage:${stored.source}` };
  }

  return { id: "1", source: "default_gr" };
}

export function debugCountry(label, data) {
  if (process.env.REACT_APP_DEBUG_COUNTRY === "1") {
    console.info(`[country] ${label}`, data);
  }
}
